// extracted by mini-css-extract-plugin
export default {"mainGrid":"RegistrationForm_mainGrid__XBskh","container":"RegistrationForm_container__kAOus","buttonContainer":"RegistrationForm_buttonContainer__wewBB"};